export const LOCATION_QUERY_CHANGE_EVENT = "metal-asia:querychange";

